import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { IPerfilamiento } from 'src/app/interfaces/usuarios';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PerfilamientoService {
  public userData = new Subject()
  @Output() getSyncUser: EventEmitter<any> = new EventEmitter()

  public menuData = new Subject()
  @Output() getSyncMenu: EventEmitter<any> = new EventEmitter()
  
  constructor(
    private http: HttpClient
  ) { }

  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  asyncMenuData(menuData: any): Observable<boolean> {
    if ( menuData ) {
      this.getSyncMenu.emit( menuData )
      return of(true)
    } else {
      this.getSyncMenu.emit('logged out')
      return of(false)
    }
  }

  asyncUserData(userData: any): Observable<boolean> {
    if ( userData ) {
      this.getSyncUser.emit( userData )
      return of(true)
    } else {
      this.getSyncUser.emit('logged out')
      return of(false)
    }
  }

  setUsuario(usuario: any) {
    const base64data = btoa(JSON.stringify(usuario))
    localStorage.setItem('usuario', base64data)
    this.asyncUserData(this.getUsuario())
  }

  getUsuario() {
    const data = localStorage.getItem('usuario')
    return data ? JSON.parse(atob(data+'')) : ''
  }

  deleteUsuario() {
    localStorage.removeItem('usuario')
  }

  setMenu(menu: any) {
    const base64data = btoa(JSON.stringify(menu))
    localStorage.setItem('menu', base64data)
    this.asyncMenuData(this.getMenu())
  }

  getMenu() {
    const data = localStorage.getItem('menu')
    return data ? JSON.parse(atob(data+'')) : ''
  }

  deleteMenu() {
    localStorage.removeItem('menu')
  }

  getPerfilamiento(): Observable<IPerfilamiento> {
    const url = `${environment.endpointAdministrativo}/v1/perfilamiento`
    return this.http.get<IPerfilamiento>(url, {headers: this.getHeaders()})
  }
}
